import React, { useState } from "react";
import {
  AvatarWrapper,
  AvatarCircle,
  AvatarBadge,
  AvatarTooltip,
  TooltipName,
  TooltipEmail,
  TooltipArrow,
} from "./Avatar.styled";

const AVATAR_COLORS = [
  "#2563eb", "#16a34a", "#dc2626", "#d97706",
  "#7c3aed", "#0891b2", "#be185d", "#0f766e", "#ea580c", "#4f46e5",
];

const avatarBg = (id) => AVATAR_COLORS[Number(id) % AVATAR_COLORS.length];

const initialsFromName = (name = "") =>
  name.trim().split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

/**
 * Circular avatar with initials and hover tooltip.
 *
 * @param {object} user        — { id, name, first_name, last_name, email }
 * @param {number} [size=26]   — avatar diameter in px
 * @param {boolean} [overlap]  — overlap with previous avatar (negative margin)
 * @param {*}  [levelBadge]    — optional small badge (e.g., audit level)
 */
const UserAvatar = ({ user, size = 26, overlap = false, levelBadge = null }) => {
  const [hovered, setHovered] = useState(false);

  const initials =
    [user.first_name?.[0], user.last_name?.[0]].filter(Boolean).join("").toUpperCase() ||
    initialsFromName(user.name) ||
    "?";

  return (
    <AvatarWrapper
      $overlap={overlap}
      $hovered={hovered}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <AvatarCircle $size={size} $bg={avatarBg(user.id)}>
        {initials}
      </AvatarCircle>

      {levelBadge != null && <AvatarBadge>{levelBadge}</AvatarBadge>}

      {hovered && (
        <AvatarTooltip>
          <TooltipName>{user.name}</TooltipName>
          {user.email && <TooltipEmail>{user.email}</TooltipEmail>}
          <TooltipArrow />
        </AvatarTooltip>
      )}
    </AvatarWrapper>
  );
};

export default UserAvatar;
